<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
    <z-page title="Carian Baka Anak">
      <div class="table_scrol">
         <div class="w-card__content content-hardcode mb3">
          <w-form v-model="valid" @validate="cari" ref="frm">
            <w-flex class="mt3">
              <z-select style="margin:5px; " v-model="pencarian.lkp_jenis_baka_id" :items="lkp_jenis_baka" label="Jenis Baka"/>
              <z-select style="margin:5px; " v-model="pencarian.premis_id" :items="premis" label="ID Premis" />
              <z-select style="margin:5px; " v-model="pencarian.lkp_status_id" :items="lkp_status" label="Status"/>
            </w-flex>
          </w-form>
          <w-flex justify-end class="mt2">
              <w-button class="mr2" v-on:click="resetPencarian()" bg-color="warning">
                  <w-icon>fal fa-redo</w-icon>&nbsp;SET SEMULA</w-button>
              <w-button class="mr2" bg-color="primary" @click="$refs.frm.validate()">
                  <w-icon>fal fa-search</w-icon>&nbsp;CARI
              </w-button>
          </w-flex>
        </div>
        <z-table title="Senarai Permohonan Baka Anak" :headers="table.headers" :items="table.items" :meta="table.meta" :mobile-breakpoint="700">
            <template #button >
                <w-button dark class="green--bg ml1" v-on="on" :route="$route('kelahiran.permohonan',0)"  v-if="$zutil.anyRole(['2','5'])">
                    <w-icon class="mr1" md >fal fa-plus</w-icon>PENDAFTARAN
                </w-button>
            </template>
          <template #header-label="{ header, label, index }">
            <template v-if="header.key == 'action'">
              <!-- <w-icon xs>fal fa-pencil</w-icon> -->
              Tindakan
            </template>
            <template v-else>
              {{ label }}
            </template>
          </template>
          <template #item-cell.status="{ item, label, header, index }">
            <w-flex class="flex justify-left">
               <template v-if="item.lkp_status_id ==21">
                  {{item.status}}<br>
                  Catatan : {{item.catatan}}
               </template>
               <template v-else>
                  {{item.status}}
               </template>
            </w-flex>
         </template>
          <template #item-cell.action="{ item, label, header, index }">
            <template v-if="$zutil.anyRole(['6','2','5'])">
               <w-tooltip md top color="white" bg-color="black" >
                <template #activator="{ on }">
                    <inertia-link :href="$route('kelahiran.permohonan.baka_show', item.id)" v-if="item.lkp_status_id ==26 || item.lkp_status_id ==18 || item.lkp_status_id ==21" v-on="on" class="w-button w-button--dark size--md info-dark1--bg"><div style="width: 8px"></div> 
                      <w-icon md class="mr2">fal fa-eye</w-icon>
                    </inertia-link>
                  </template>
                  Papar
               </w-tooltip>

               <w-tooltip md top color="white" bg-color="black" >
                <template #activator="{ on }">
                    <inertia-link :href="$route('kelahiran.permohonan.baka_ternakan', item.id)" v-if="item.lkp_status_id ==31 || item.lkp_status_id ==34" v-on="on" class="w-button w-button--dark size--md info-dark1--bg"><div style="width: 8px"></div> 
                      <w-icon md class="mr2">fal fa-eye</w-icon>
                    </inertia-link>
                  </template>
                  Papar
               </w-tooltip>
            </template>
            <w-flex class="flex justify-center">
               <w-tooltip top color="white" bg-color="black">
                        <template #activator="{ on }">
                           <w-button  bg-color="warning" v-on="on" v-if="item.lkp_status_id ==19 && $zutil.anyRole(['2','5'])" :route="$route('kelahiran.permohonan',item.id)" class="be fs-2"><div style="width: 8px"></div>
                              <w-icon md class="mr2">fal fa-pencil</w-icon>
                           </w-button>
                           <w-button  bg-color="warning" v-on="on" v-if="item.lkp_status_id ==19 && $zutil.anyRole(['4'])" :route="$route('kelahiran.permohonan',item.id)" class="be fs-2"><div style="width: 8px"></div>
                              <w-icon md class="mr2">fal fa-pencil</w-icon>
                           </w-button>
                        </template>
                        Kemaskini
                     </w-tooltip>

                     &nbsp;
                     <w-tooltip md top align-left color="white" bg-color="black" >
                        <template #activator="{ on }">
                           <w-button  bg-color="info" v-on="on"  v-if=" $zutil.anyRole(['2','5']) && item.lkp_status_id ==21 && item.baka_salinan == null" @click="Salin(item.id)" class="be fs-2"><div style="width: 8px"></div>
                              <w-icon md class="mr2">fal fa-copy</w-icon>
                           </w-button>
                        </template>
                        Salin
                     </w-tooltip>
                     &nbsp;
                     <template v-if="$zutil.anyRole(['2','5']) && item.lkp_status_id ==21 && item.baka_salinan != null">
                      Baka Sudah Tersalin 
                     </template>
                     &nbsp;
         <template v-if="$zutil.anyRole(['4'])">       
            <w-tooltip md top color="white" bg-color="black" >
                <template #activator="{ on }">
                    <inertia-link :href="$route('kelahiran.permohonan.show', item.id)" v-if="item.lkp_status_id ==45 ||item.lkp_status_id ==31" v-on="on" class="w-button w-button--dark size--md info-dark1--bg"><div style="width: 8px"></div> 
                      <w-icon md class="mr2">fal fa-eye</w-icon>
                    </inertia-link>
                 </template>
                  Papar 
                </w-tooltip>
            <w-tooltip md top color="white" bg-color="black" > 
                <template #activator="{ on }">
                    <inertia-link :href="$route('kelahiran.permohonan.baka_show', item.id)" v-if="item.lkp_status_id ==34 ||item.lkp_status_id == 26 ||item.lkp_status_id == 18 || item.lkp_status_id == 21  " v-on="on" class="w-button w-button--dark size--md info-dark1--bg"><div style="width: 8px"></div> 
                      <w-icon md class="mr2">fal fa-eye</w-icon>
                    </inertia-link>
                 </template>
                  Papar 
                </w-tooltip>
               </template>

            </w-flex>
          </template>
        </z-table>
      </div>
    </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    items: [Array, Object],
    segmenName: [Array, Object]
  },
  data() {
    return {
      resourceurl: 'kelahiran.'+this.segmenName,
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Baka Anak', route: '/kelahiran' },
      ],
      form : this.d_form,
      form_salinan : {},
      

      pencarian: {
         premis_id: '',
         lkp_status_id: '',
         lkp_jenis_baka_id: '',
      },
      premis: [],
      lkp_status :[],
      lkp_jenis_baka : [],
      
      
    }
  },
  methods: {
   
   cari() {
       if(!this.valid) return;

       let params = {
       ...this.pencarian,
       };
       params.page = 1;
       this.$inertia.visit(route(route().current(), params), {
           preserveState: true,
           preserveScroll: true,
       });
    },

    resetPencarian() {
       this.$inertia.visit(route(route().current()));
    },

    getStatus(){
      this.$zcomm.get(this.api_service + 'lookup/status_baka', {}).then(res => {
        this.lkp_status = res
      })
    },

    getPremis(){
     this.$zcomm.get(this.api_service + 'lookup/premis', {}).then(res => {
       this.premis = res
     })
   },
   getJenisBaka(){
      this.$zcomm.get(this.api_service + 'lookup/jenis_baka', {}).then(res => {
        this.lkp_jenis_baka = res
      })
    },

  Salin(item) {

             this.$swal({
                title: 'Anda Pasti Salin Baka?',
            // text: "Are you sure want to delete this item!",
               type: 'warning',
               showCancelButton: true,
               confirmButtonColor: '#3085d6',
               cancelButtonColor: '#d33',
               confirmButtonText: 'Ya',
               cancelButtonText: 'Tidak'
             }).then((result) => {
               if (result.value) {

                 this.form_salinan.baka_id = item;

                 this.$zcomm.post('kelahiran.salin_baka_anak', this.form_salinan)
                 .then(res => {
                    this.$zutil.notify("Baka berjaya disalin", true);
                    // this.$inertia.visit(this.$route('baka.index', res.id));
                    this.$inertia.visit(this.$route('kelahiran.permohonan', res.id));
                  })
                 .catch(error => {
                    this.$zutil.notify("Ralat ketika Salin Baka", false);
                    console.error(error);
                  })
                 .finally(() => {
                    this.loading = false;
                  });
               }else{ }
             })
           // }

           
         },


  },

  watch: {

  },
  mounted() {
   this.getStatus();
   this.getPremis();;
   this.getJenisBaka();
    // override default setting
    this.dialog.width = 500
      
  },
}
</script>
